"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _WishlistActions = _interopRequireDefault(require("./components/WishlistActions"));
var _WishlistItem = _interopRequireDefault(require("./components/WishlistItem"));
var _WishlistPlaceholder = _interopRequireDefault(require("./components/WishlistPlaceholder"));
var _excluded = ["items", "className", "onPackageClicked", "onHotelClicked", "onRemoveWishlistItem", "isLoggedIn", "children"];
var Wishlist = function Wishlist(props) {
  var _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    onPackageClicked = props.onPackageClicked,
    onHotelClicked = props.onHotelClicked,
    onRemoveWishlistItem = props.onRemoveWishlistItem,
    isLoggedIn = props.isLoggedIn,
    children = props.children,
    actions = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var lastItem = !(0, _isEmpty2["default"])(items) ? items[items.length - 1] : null;
  return /*#__PURE__*/_react["default"].createElement(StyledWishlist, {
    className: className
  }, (0, _isEmpty2["default"])(items) ? /*#__PURE__*/_react["default"].createElement(_WishlistPlaceholder["default"], null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isLoggedIn ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(WishlistContainer, null, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_WishlistItem["default"], (0, _extends2["default"])({
      key: item.link,
      onPackageClicked: onPackageClicked,
      onHotelClicked: onHotelClicked
    }, item, {
      onClick: onRemoveWishlistItem,
      isLoggedIn: isLoggedIn
    }));
  })), /*#__PURE__*/_react["default"].createElement(_WishlistActions["default"], actions)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(WishlistContainer, null, /*#__PURE__*/_react["default"].createElement(ChildrenContainer, null, children), lastItem && /*#__PURE__*/_react["default"].createElement(_WishlistItem["default"], (0, _extends2["default"])({
    key: lastItem.link,
    onPackageClicked: onPackageClicked,
    onHotelClicked: onHotelClicked
  }, lastItem, {
    onClick: onRemoveWishlistItem,
    isLoggedIn: isLoggedIn
  }))))));
};
var StyledWishlist = _styledComponents["default"].div.withConfig({
  displayName: "Wishlist__StyledWishlist",
  componentId: "sc-1md6e3i-0"
})([""]);
var WishlistContainer = _styledComponents["default"].ul.withConfig({
  displayName: "Wishlist__WishlistContainer",
  componentId: "sc-1md6e3i-1"
})(["max-height:calc(100vh - 205px);overflow-y:scroll;"]);
var ChildrenContainer = _styledComponents["default"].div.withConfig({
  displayName: "Wishlist__ChildrenContainer",
  componentId: "sc-1md6e3i-2"
})(["z-index:1;"]);
var _default = exports["default"] = Wishlist;